import React from 'react'

import styles from './SmallWidgetTimezones.module.scss'

type SmallWidgetTimezonesProps = {
  timezones: string[]
  getZonedDate: (timeZone: string, base: Date) => Date
  tzName: (tz: string) => string
  LiveClock: React.ComponentType<{
    timeZone: string
    size: number
    renderMinuteMarks?: boolean
  }>
}

export const SmallWidgetTimezones: React.FC<SmallWidgetTimezonesProps> = ({
  timezones,
  tzName,
  LiveClock
}) => {
  return (
    <div className={styles.clocksGrid}>
      {timezones.slice(0, 4).map((tz, index) => (
        <div key={tz + index} className={styles.clockItem}>
          <LiveClock timeZone={tz} size={40} renderMinuteMarks={false} />
          <div className={styles.tzLabel}>{tzName(tz)}</div>
        </div>
      ))}
    </div>
  )
}
